<div class="labels" *ngIf="interactive && (showLabels$ | async)">
  <app-label *ngFor="let label of labels$ | async; trackBy: trackLabel" [label]="label"></app-label>

  <app-label [label]="contextLabel$ | async" *ngIf="(enableContextLabel$ | async) && (contextLabel$ | async)"></app-label>
</div>
